import React from 'react';
import PropTypes from 'prop-types';
import { colourMaster, colourDanger, colourPrimary } from 'Styles/colors.css';
import Icons from './Icons/index';

const colours = {
  default: colourMaster,
  danger: colourDanger,
  primary: colourPrimary,
};

const Icon = ({ type, appearance, size }) => {
  const Component = Icons[type];
  const colour = colours[appearance];

  return (
    <Component
      colour={colour}
      size={size}
    />
  );
};

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  appearance: PropTypes.string,
  size: PropTypes.number,
};

Icon.defaultProps = {
  appearance: 'default',
  size: 20,
};

export default Icon;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/Icon/Icon.jsx